import { createSlice } from "@reduxjs/toolkit";
import {
  checkAccessStatus,
  getActionStatus,
  AccessStartEndTime,
  loadFileAndKid,
  sendKeyAuthorizedUser,
  updateManualReview,
  getAuditDetails,
  updateCallEvaluationStatus,
  getAuditList,
  getManualReview,
  evaluationDashboardCounts,
  agentDashboardCounts,
  agentLeaderBoardData,
  agentOutlierReportData,
  failureCountByCategoryChart,
  agentScoringSentiments,
  getTopViolationsByCategories,
  getCampaigns,
  topTenViolationsByCategories,
  getAgentList,
  getQaSupervisorList,
  getAgentPerformanceKpis,
  getPurposeCallDistribution,
  getCallSentimentVsScore,
  getSentimentAnalysis,
  getSentimentWordCloud,
  getEmotionAnalysis,
  getSentimentTiming,
  getConversationalTagMappings,
  getConversationalTags
} from "../services/audit.service";
import { prepareManualDataResponse, } from "../views/ai-evaluation/components/CallReviewTable";

const initialState = {
  // list api variables
  listLoader: false,
  listData: [],
  totalListCount: 0,
  listErrorMsg: "",
  // details api variable
  auditDetailsLoader: false,
  successMsg: "",
  errorMsg: "",
  auditDetails: null,
  // check status Access api variable
  checkConstarLoader: false,
  checkAccessStatusData: null,
  checkAccessSuccessMsg: "",
  checkAccessErrorMsg: "",
  // Get Action status api variable
  actionStatusLoader: false,
  actionStatusData: null,
  actionStatusSuccessMsg: "",
  actionStatusErrorMsg: "",
  // Start End time api variable
  accessStartEndTimeData: null,
  accessStartEndLoader: false,
  accessStartEndSuccessMsg: "",
  accessStartEndErrorMsg: "",
  // load file api variables
  loadFileLoader: false,
  loadFileAndKidData: null,
  loadFileSuccessMsg: "",
  loadFileErrorMsg: "",
  // send key authorize user api variables
  sendKeyAuthLoader: false,
  sendKeyAuthorizedUserData: null,
  sendKeyAuthorizedSuccessMsg: "",
  sendKeyAuthorizedErrorMsg: undefined,
  // manual override api variables
  updateManualReviewLoader: false,
  updateManualReviewData: null,
  updateManualReviewSuccessMsg: "",
  updateManualReviewErrorMsg: "",
  // update Status api variable
  changeStatusLoader: false,
  changeStatusData: null,
  changeStatusSuccessMsg: "",
  changeStatusErrorMsg: "",
  // set discussion panel comments
  comments: null,
  // call review toggle button handling
  isEditModeOn: false,
  isAIReviewModeOn: false,
  manualReview: null,
  isAIEvaluation: false,
  // sub question audio slice
  subQuestionAudioSliceTime: 0,
  // manual review
  manualReviewLoader: false,
  manualReviewData: null,
  // evaluation dashboard KPI
  dashboardCountsLoader: false,
  dashboardCountsData: null,
  dashboardCountsErrMsg: "",
  // Agent Dashboard api
  agentDashboardApiErrMsg: "",
  agentDashboardCountsData: [],
  agentDashboardCountsLoader: false,
  //evaluation signature
  signatureImage: "",
  //Agent LeaderBoard Api
  agentLeaderBoardCountsData: [],
  agentLeaderBoardApiErrMsg: "",
  agentLeaderBoardDataLoader: false,
  //Agent Outlier Board Api
  agentOutlierBoardCountsData: [],
  agentOutlierBoardApiErrMsg: "",
  agentOutlierBoardDataLoader: false,
  //failure Count Chart
  failureCountsCategoryChartData: {},
  failureCountsCategoryApiErrMsg: "",
  failureCountsCategoryLoader: false,
  //agentscoring sentiment
  agentscoringsentimentData: [],
  agentscoringsentimentApiErrMsg: "",
  agentscoringsentimentLoader: false,
  // Top Violations By Categories
  topViolationsByCategoriesData: [],
  topViolationsByCategoriesErrMsg: "",
  topViolationsByCategoriesLoader: false,
  // Campaign list
  campaigns: {
    data: [],
    loader: false,
    errorMsg: "",
  },
  // agent list
  agent: {
    data: [],
    loader: false,
    errorMsg: "",
  },
  // qa supervisor list
  qaSupervisor: {
    data: [],
    loader: false,
    errorMsg: ""
  },
  //Top 10 violations sentiment
  topTenViolationsData: [],
  topTenViolationsApiErrMsg: "",
  topTenViolationsLoader: false,

  //Agent Performance KPI
  agentPerformanceKpiData: {},
  agentPerformanceKpiApiErrMsg: "",
  agentPerformanceKpiLoader: false,
  //Purpose Call Distribution
  purposeCallDistributionData: [],
  purposeCallDistributionErrMsg: "",
  purposeCallDistributionLoader: false,
  //Call Sentiment VS Score
  callSentimentvsScoreData: [],
  callSentimentvsScoreErrMsg: "",
  callSentimentvsScoreLoader: false,
  //sentiment Word Cloud
  sentimentWordCloudLoader: false,
  sentimentWordCloudChartData: [],
  sentimentWordCloudApiErrMsg: "",
  //sentiment Analysis 
  sentimentAnalysisChartData: [],
  sentimentAnalysisLoader: false,
  sentimentAnalysisApiErrMsg: "",
  //emotion analysis
  emotionAnalysisChartData: {},
  emotionAnalysisLoader: false,
  emotionAnalysisApiErrMsg: "",
  emotionAnalysisApiSuccessMsg: "",
  statementStartTime: "",
  statementEndTime: "",
  //sentiment timing
  sentimentTimingChartData: [],
  sentimentTimingLoader: false,
  sentimentTimingApiErrMsg: "",
  //audio play /pause 
  audioTimeStampData :{
   startTimestamp:null,
   shouldPlay :false,
  },
  isGlobalCurrentAudioPlaying: '',
  // Conversation tags list api variables
  ConversationalTagsLoader: false,
  ConversationalTagsData: [],
  ConversationalTagsErrorMsg: "",
  // Conversation tags list api variables
  ConversationalTagMappingsLoader: false,
  ConversationalTagMappingsData: [],
  ConversationalTagMappingsCount: 0,
  ConversationalTagMappingsErrorMsg: "",
};

const AuditSlice = createSlice({
  name: "audit",
  initialState: initialState,
  reducers: {
    setComments: (state, action) => {
      state.comments = action.payload?.filter((msg: any) => msg.comment);
    },
    setIsEditModeOn: (state, action) => {
      state.isEditModeOn = action.payload;
    },
    setAIEvaluation: (state, action) => {
      state.isAIEvaluation = action.payload;
    },
    setIsAiReviewModeOn: (state, action) => {
      state.isAIReviewModeOn = action.payload;
    },
    setManualReview: (state, action) => {
      state.manualReview = action.payload;
    },
    seekSubQuestionAudioSlice: (state, action) => {
      state.subQuestionAudioSliceTime = action.payload;
    },
    setSignatureImage: (state, action) => {
      state.signatureImage = action.payload;
    },
    setAudioTimeStampData: (state, action) => {
      state.audioTimeStampData = {
        ...state.audioTimeStampData,
        ...action.payload,
      };
    },
    setStatementAudioTime: (state, action) => {
      state.statementStartTime = action.payload.startTime;
      state.statementEndTime = action.payload.endTime;
    },
    setIsGlobalAudioPlaying: (state,action) => {
      state.isGlobalCurrentAudioPlaying = action.payload
    },
    setGlobalAudioStopped: (state) => {
      state.isGlobalCurrentAudioPlaying = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuditDetails.pending, (state, action) => {
        state.auditDetailsLoader = true;
      })
      .addCase(getAuditDetails.fulfilled, (state, action: any) => {
        state.auditDetails = action.payload;
        state.auditDetailsLoader = false;
        state.successMsg = action.payload.message;
      })
      .addCase(getAuditDetails.rejected, (state, action) => {
        state.auditDetailsLoader = false;
        state.errorMsg = action.error.message
          ? action.error.message
          : "Something went wrong in details Api Error";
      })
      .addCase(checkAccessStatus.pending, (state, action) => {
        state.checkConstarLoader = true;
      })
      .addCase(checkAccessStatus.fulfilled, (state, action: any) => {
        state.checkAccessStatusData = action.payload?.data;
        state.checkConstarLoader = false;
        state.checkAccessSuccessMsg = action.payload.message;
      })
      .addCase(checkAccessStatus.rejected, (state, action) => {
        state.checkConstarLoader = false;
        state.checkAccessErrorMsg = action.error.message
          ? action.error.message
          : "get action status Api Error";
      })
      .addCase(getActionStatus.pending, (state, action) => {
        state.actionStatusLoader = true;
      })
      .addCase(getActionStatus.fulfilled, (state, action: any) => {
        state.actionStatusData = action.payload?.data;
        state.actionStatusLoader = false;
        state.actionStatusSuccessMsg = action.payload.message;
      })
      .addCase(getActionStatus.rejected, (state, action) => {
        state.actionStatusErrorMsg = action.error.message
          ? action.error.message
          : "get action status Api Error";
      })
      .addCase(AccessStartEndTime.pending, (state, action) => {
        state.accessStartEndLoader = true;
      })
      .addCase(AccessStartEndTime.fulfilled, (state, action: any) => {
        state.accessStartEndTimeData = action.payload?.data;
        state.accessStartEndLoader = false;
        state.accessStartEndSuccessMsg = action.payload.message;
      })
      .addCase(AccessStartEndTime.rejected, (state, action) => {
        state.accessStartEndErrorMsg = action.error.message
          ? action.error.message
          : "get action status Api Error";
      })
      .addCase(loadFileAndKid.pending, (state, action) => {
        state.loadFileLoader = true;
      })
      .addCase(loadFileAndKid.fulfilled, (state, action: any) => {
        state.loadFileAndKidData = action.payload;
        state.loadFileLoader = false;
      })
      .addCase(loadFileAndKid.rejected, (state, action: any) => {
        state.loadFileLoader = false;
        state.loadFileErrorMsg =
          action.payload?.message ?? "get action status Api Error";
      })
      .addCase(sendKeyAuthorizedUser.pending, (state, action) => {
        state.sendKeyAuthLoader = true;
      })
      .addCase(sendKeyAuthorizedUser.fulfilled, (state, action: any) => {
        state.sendKeyAuthorizedUserData = action.payload;
        state.sendKeyAuthLoader = false;
        state.sendKeyAuthorizedSuccessMsg = action.payload.message;
      })
      .addCase(sendKeyAuthorizedUser.rejected, (state, action: any) => {
        state.sendKeyAuthLoader = false;
        state.sendKeyAuthorizedErrorMsg =
          action?.payload?.error ?? "get action status Api Error";
      })
      .addCase(updateManualReview.pending, (state, action) => {
        state.updateManualReviewLoader = true;
      })
      .addCase(updateManualReview.fulfilled, (state, action: any) => {
        state.updateManualReviewData = action.payload?.data;
        state.updateManualReviewLoader = false;
        state.updateManualReviewSuccessMsg = action.payload.message;
      })
      .addCase(updateManualReview.rejected, (state, action) => {
        state.updateManualReviewLoader = false;
        state.updateManualReviewErrorMsg = action.error.message
          ? action.error.message
          : "get action status Api Error";
      })
      .addCase(updateCallEvaluationStatus.pending, (state, action) => {
        state.changeStatusLoader = true;
      })
      .addCase(updateCallEvaluationStatus.fulfilled, (state, action: any) => {
        state.changeStatusData = action.payload?.data;
        state.changeStatusLoader = false;
        state.updateManualReviewSuccessMsg = action?.payload?.message;
      })
      .addCase(updateCallEvaluationStatus.rejected, (state, action) => {
        state.changeStatusLoader = false;
        state.updateManualReviewErrorMsg = action?.error?.message
          ? action.error.message
          : "get action status Api Error";
      })
      .addCase(getAuditList.pending, (state, action) => {
        state.listLoader = true;
      })
      .addCase(getAuditList.fulfilled, (state, action) => {
        state.listLoader = false;
        state.listData = action.payload?.results;
        state.totalListCount = action.payload?.count;
      })
      .addCase(getAuditList.rejected, (state, action) => {
        state.listLoader = false;
        state.listErrorMsg =
          action?.error?.message ?? "something went wrong in list api";
      })
      .addCase(getConversationalTagMappings.pending, (state, action) => {
        state.ConversationalTagMappingsLoader = true;
      })
      .addCase(getConversationalTagMappings.fulfilled, (state, action) => {
        state.ConversationalTagMappingsLoader = false;
        state.ConversationalTagMappingsData = action.payload?.data?.results;
        state.ConversationalTagMappingsCount = action.payload?.count;
      })
      .addCase(getConversationalTagMappings.rejected, (state, action) => {
        state.ConversationalTagMappingsLoader = false;
        state.ConversationalTagMappingsErrorMsg =
          action?.error?.message ?? "something went wrong in list api";
      })
      .addCase(getManualReview.pending, (state, action) => {
        state.manualReviewLoader = true;
      })
      .addCase(getManualReview.fulfilled, (state, action: any) => {
        state.manualReviewData = prepareManualDataResponse(action.payload);
        state.manualReviewLoader = false;
      })
      .addCase(getManualReview.rejected, (state, action) => {
        state.manualReviewLoader = false;
      })
      .addCase(getConversationalTags.pending, (state, action) => {
        state.ConversationalTagsLoader = true;
      })
      .addCase(getConversationalTags.fulfilled, (state, action) => {
        state.ConversationalTagsLoader = false;
        state.ConversationalTagsData = action.payload;
      })
      .addCase(getConversationalTags.rejected, (state, action) => {
        state.ConversationalTagsLoader = false;
        state.ConversationalTagsErrorMsg =
          action?.error?.message ?? "something went wrong in list api";
      })
      .addCase(evaluationDashboardCounts.pending, (state) => {
        state.dashboardCountsLoader = true;
      })
      .addCase(evaluationDashboardCounts.fulfilled, (state, action: any) => {
        state.dashboardCountsData = action.payload;
        state.dashboardCountsLoader = false;
      })
      .addCase(
        evaluationDashboardCounts.rejected,
        (state: any, action: any) => {
          state.dashboardCountsErrMsg = action.payload?.error ?? "Ai Api Error";
          state.dashboardCountsLoader = false;
        }
      )
      .addCase(agentDashboardCounts.pending, (state, action) => {
        state.agentDashboardCountsLoader = true;
      })
      .addCase(agentDashboardCounts.fulfilled, (state, action: any) => {
        state.agentDashboardCountsData = action.payload;
        state.agentDashboardCountsLoader = false;
      })
      .addCase(agentDashboardCounts.rejected, (state, action: any) => {
        state.agentDashboardApiErrMsg =
          action.payload?.error ?? "Agent Dashboard Api Error";
        state.agentDashboardCountsLoader = false;
      })

      .addCase(agentLeaderBoardData.pending, (state, action: any) => {
        state.agentLeaderBoardDataLoader = true;
      })
      .addCase(agentLeaderBoardData.fulfilled, (state, action: any) => {
        state.agentLeaderBoardCountsData = action.payload;
        state.agentLeaderBoardDataLoader = false;
      })
      .addCase(agentLeaderBoardData.rejected, (state, action: any) => {
        state.agentLeaderBoardApiErrMsg =
          action.payload?.error ?? "Agent Leader Board Api Error";
        state.agentLeaderBoardDataLoader = false;
      })
      .addCase(agentOutlierReportData.pending, (state, action: any) => {
        state.agentOutlierBoardDataLoader = true;
      })
      .addCase(agentOutlierReportData.fulfilled, (state, action: any) => {
        state.agentOutlierBoardCountsData = action.payload;
        state.agentOutlierBoardDataLoader = false;
      })
      .addCase(agentOutlierReportData.rejected, (state, action: any) => {
        state.agentOutlierBoardApiErrMsg =
          action.payload?.error ?? "Outlier data  Api Error";
        state.agentOutlierBoardDataLoader = false;
      })
      .addCase(failureCountByCategoryChart.pending, (state, action: any) => {
        state.failureCountsCategoryLoader = true;
      })
      .addCase(failureCountByCategoryChart.fulfilled, (state, action: any) => {
        state.failureCountsCategoryChartData = action.payload;
        state.failureCountsCategoryLoader = false;
      })
      .addCase(failureCountByCategoryChart.rejected, (state, action: any) => {
        state.failureCountsCategoryApiErrMsg =
          action.payload?.error ?? "Failure count by category  Api Error";
        state.failureCountsCategoryLoader = false;
      })
      .addCase(agentScoringSentiments.pending, (state, action: any) => {
        state.agentscoringsentimentLoader = true;
      })
      .addCase(agentScoringSentiments.fulfilled, (state, action: any) => {
        state.agentscoringsentimentData = action.payload;
        state.agentscoringsentimentLoader = false;
      })
      .addCase(agentScoringSentiments.rejected, (state, action: any) => {
        state.agentscoringsentimentApiErrMsg =
          action.payload?.error ?? "Failure Agent scoring Api Error";
        state.agentscoringsentimentLoader = false;
      })
      .addCase(getTopViolationsByCategories.pending, (state, action) => {
        state.topViolationsByCategoriesLoader = true;
      })
      .addCase(getTopViolationsByCategories.fulfilled, (state, action: any) => {
        state.topViolationsByCategoriesData = action.payload;
        state.topViolationsByCategoriesLoader = false;
      })
      .addCase(getTopViolationsByCategories.rejected, (state, action: any) => {
        state.topViolationsByCategoriesErrMsg =
          action.payload?.error ?? "Api Error";
        state.topViolationsByCategoriesLoader = false;
        state.topViolationsByCategoriesData = [];
      })
      .addCase(getCampaigns.pending, (state, action) => {
        state.campaigns = { ...state.campaigns, loader: true };
      })
      .addCase(getCampaigns.fulfilled, (state, action: any) => {
        state.campaigns = {
          ...state.campaigns,
          data: action.payload?.data?.results,
          loader: false,
        };
      })
      .addCase(getCampaigns.rejected, (state, action) => {
        state.campaigns = {
          ...state.campaigns,
          errorMsg: action.error.message ?? "error",
          loader: false,
        };
      })
      .addCase(topTenViolationsByCategories.pending, (state, action) => {
        state.topTenViolationsLoader = true;
      })
      .addCase(topTenViolationsByCategories.fulfilled, (state, action: any) => {
        state.topTenViolationsData = action.payload;
        state.topTenViolationsLoader = false;
      })
      .addCase(topTenViolationsByCategories.rejected, (state, action: any) => {
        state.topTenViolationsApiErrMsg = action.payload?.error ?? "Api Error";
        state.topTenViolationsLoader = false;
      })
      .addCase(getAgentList.pending, (state, action) => {
        state.agent = { ...state.agent, loader: true };
      })
      .addCase(getAgentList.fulfilled, (state, action: any) => {
        state.agent = {
          ...state.agent,
          data: action.payload?.data?.results,
          loader: false,
        };
      })
      .addCase(getAgentList.rejected, (state, action) => {
        state.agent = {
          ...state.agent,
          errorMsg: action.error.message ?? "error",
          loader: false,
        };
      })
      .addCase(getQaSupervisorList.pending, (state, action) => {
        state.qaSupervisor = { ...state.qaSupervisor, loader: true };
      })
      .addCase(getQaSupervisorList.fulfilled, (state, action: any) => {
        state.qaSupervisor = {
          ...state.qaSupervisor,
          data: action.payload?.data?.results,
          loader: false,
        };
      })
      .addCase(getQaSupervisorList.rejected, (state, action) => {
        state.qaSupervisor = { ...state.qaSupervisor, errorMsg: action.error.message ?? "error", loader: false };
      })
      .addCase(getSentimentAnalysis.pending, (state, action: any) => {
        state.sentimentAnalysisLoader = true;
      })
      .addCase(getSentimentAnalysis.fulfilled, (state, action: any) => {
        state.sentimentAnalysisChartData = action.payload;
        state.sentimentAnalysisLoader = false;
      })
      .addCase(getSentimentAnalysis.rejected, (state, action: any) => {
        state.sentimentAnalysisApiErrMsg =
          action.payload?.error ?? "Failure count by category  Api Error";
        state.sentimentAnalysisLoader = false;
      })
      .addCase(getSentimentWordCloud.pending, (state, action: any) => {
        state.sentimentWordCloudLoader = true;
      })
      .addCase(getSentimentWordCloud.fulfilled, (state, action: any) => {
        state.sentimentWordCloudChartData = action.payload;
        state.sentimentWordCloudLoader = false;
      })
      .addCase(getSentimentWordCloud.rejected, (state, action: any) => {
        state.sentimentWordCloudApiErrMsg =
          action.payload?.error ?? "Failure count by category  Api Error";
        state.sentimentWordCloudLoader = false;
      })
      .addCase(getEmotionAnalysis.pending, (state, action: any) => {
        state.emotionAnalysisLoader = true;
      })
      .addCase(getEmotionAnalysis.fulfilled, (state, action: any) => {
        state.emotionAnalysisChartData = action.payload;      
        state.emotionAnalysisApiSuccessMsg = action.payload?.message;
        state.emotionAnalysisLoader = false;
      })
      .addCase(getEmotionAnalysis.rejected, (state, action: any) => {
        state.emotionAnalysisApiErrMsg =
          action.payload?.error ?? "Failure count by category  Api Error";
        state.emotionAnalysisLoader = false;
      })
      .addCase(getSentimentTiming.pending, (state, action: any) => {
        state.sentimentTimingLoader = true;
      })
      .addCase(getSentimentTiming.fulfilled, (state, action: any) => {
        state.sentimentTimingChartData = action.payload;
        state.sentimentTimingLoader = false;
      })
      .addCase(getSentimentTiming.rejected, (state, action: any) => {
        state.sentimentTimingApiErrMsg =
          action.payload?.error ?? "Failure count by category  Api Error";
        state.sentimentTimingLoader = false;
      })

      .addCase(getAgentPerformanceKpis.pending, (state, action) => {
        state.agentPerformanceKpiLoader = true;
      })
      .addCase(getAgentPerformanceKpis.fulfilled, (state, action: any) => {
        state.agentPerformanceKpiData = action.payload;
        state.agentPerformanceKpiLoader = false;
      })
      .addCase(getAgentPerformanceKpis.rejected, (state, action: any) => {
        state.agentPerformanceKpiApiErrMsg =
          action.payload?.error ?? "Api Error";
        state.agentPerformanceKpiLoader = false;
      })
      .addCase(getPurposeCallDistribution.pending, (state, action) => {
        state.purposeCallDistributionLoader = true;
      })
      .addCase(getPurposeCallDistribution.fulfilled, (state, action: any) => {
        state.purposeCallDistributionData = action.payload;
        state.purposeCallDistributionLoader = false;
      })
      .addCase(getPurposeCallDistribution.rejected, (state, action: any) => {
        state.purposeCallDistributionData = [];
        state.purposeCallDistributionErrMsg =
          action.payload?.error ?? "Api Error";
        state.purposeCallDistributionLoader = false;
      })
      .addCase(getCallSentimentVsScore.pending, (state, action) => {
        state.callSentimentvsScoreLoader = true;
      })
      .addCase(getCallSentimentVsScore.fulfilled, (state, action: any) => {
        state.callSentimentvsScoreData = action.payload;
        state.callSentimentvsScoreLoader = false;
      })
      .addCase(getCallSentimentVsScore.rejected, (state, action: any) => {
        state.callSentimentvsScoreErrMsg =
          action.payload?.error ?? "Api Error";
        state.callSentimentvsScoreLoader = false;
      });
  },
});
export const {
  setComments,
  setIsEditModeOn,
  setIsAiReviewModeOn,
  setManualReview,
  setAIEvaluation,
  seekSubQuestionAudioSlice,
  setSignatureImage,
  setAudioTimeStampData,
  setStatementAudioTime,
  setIsGlobalAudioPlaying,
  setGlobalAudioStopped
} = AuditSlice.actions;
export default AuditSlice.reducer;
